import { PageItemApi } from 'api/PageItemApi';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { QuestionAbstractMapper } from 'mapper/QuestionAbstractMapper';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { PageItemKind } from 'model/PageItemKind';
import { QuestionForm } from 'model/QuestionForm';

export class QuestionFormMapper
  implements PageItemKindMapper<QuestionForm, PageItemApi.QuestionFormEntry>
{
  constructor() {}

  serialize(model: QuestionForm): PageItemApi.QuestionFormEntry {
    return {
      ...QuestionAbstractMapper.serialize(model),
      options: model.options,
      optionHeight: model.optionHeight,
      numberingSkipped: model.numberingSkipped ? 1 : 0,
    };
  }

  deserialize(entry: PageItemApi.QuestionFormEntry): QuestionForm {
    return {
      ...QuestionAbstractMapper.deserializeShape(entry),
      options: (entry.options || []).sort((a, b) => a.position - b.position),
      optionHeight: entry.optionHeight,
      numberingSkipped: Boolean(entry.numberingSkipped),
    };
  }

  supportsSerialize(model: PageItemModel): boolean {
    return model.kind === PageItemKind.QuestionForm;
  }

  supportsDeserialize(entry: PageItemApi.ImageWidgetEntry): boolean {
    return entry.kind === PageItemKind.QuestionForm;
  }
}
